import classNames from 'classnames';
import { forwardRef } from 'react';
const switchWrapperCss = "s1uk6fce";
export const SwitchWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchWrapperCss, props.className)} />;
});
const sectionContentWrapperCss = "s5tyaod";
export const SectionContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionContentWrapperCss, props.className)} />;
});
const sectionWrapperCss = "s1unx477";
export const SectionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionWrapperCss, props.className)} />;
});
const sectionTitleWrapperCss = "s8se771";
export const SectionTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionTitleWrapperCss, props.className)} />;
});
const mobileSectionTitleWrapperCss = "m17ln0ji";
export const MobileSectionTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileSectionTitleWrapperCss, props.className)} />;
});
const mobileSectionWrapperCss = "mmkhe2o";
export const MobileSectionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileSectionWrapperCss, props.className)} />;
});
const titleWrapperCss = "tx4jiuh";
export const TitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleWrapperCss, props.className)} />;
});
const mobileTitleWrapperCss = "mchqxc1";
export const MobileTitleWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileTitleWrapperCss, props.className)} />;
});
const sectionRightContentRowCss = "s1xmklce";
export const SectionRightContentRow = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionRightContentRowCss, props.className)} />;
});
const connectedWrapperCss = "c1kfzoev";
export const ConnectedWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(connectedWrapperCss, props.className)} />;
});
const dropdownWrapperCss = "dwv359u";
export const DropdownWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownWrapperCss, props.className)} />;
});
const dropdownErrorWrapperCss = "d1ydnqw6";
export const DropdownErrorWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownErrorWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");